var _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvantageIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 40,
    viewBox: "0 0 48 40",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 40,
    width: 52,
    x: -2,
    y: 0
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_1_269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_269",
    mode: "normal",
    result: "shape"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30 32c-4.4667 0-8.25-1.55-11.35-4.65s-4.65-6.8833-4.65-11.35 1.55-8.25 4.65-11.35 6.8833-4.65 11.35-4.65 8.25 1.55 11.35 4.65 4.65 6.8833 4.65 11.35-1.55 8.25-4.65 11.35-6.8833 4.65-11.35 4.65zm-.012-3c3.608 0 6.6787-1.2627 9.212-3.788 2.5333-2.5257 3.8-5.5923 3.8-9.2 0-3.608-1.2627-6.67867-3.788-9.212-2.5257-2.53333-5.5923-3.8-9.2-3.8-3.608 0-6.6787 1.26267-9.212 3.788-2.5333 2.52567-3.8 5.5923-3.8 9.2 0 3.608 1.2627 6.6787 3.788 9.212 2.5257 2.5333 5.5923 3.8 9.2 3.8zm5.112-5.85 2.1-2.1-5.7-5.7v-7.35h-3v8.6zm-31.1-13.65v-3h8v3zm-2 8v-3h10v3zm2 8v-3h8v3z",
    fill: "#fcc241"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvantageIcon1);
export default __webpack_public_path__ + "static/media/advantage-icon-1.327fab238abef58e804186a3dbfd5293.svg";
export { ForwardRef as ReactComponent };